import type { SecurityDevice, SecurityEvent, TransactionLimit } from '../../types';
import { MOCK_DEVICES, MOCK_LIMITS, MOCK_SECURITY_EVENTS } from '../../lib/mockData';
import { request } from '../api/client';

let limits = [...MOCK_LIMITS];
let devices = [...MOCK_DEVICES];

export const securityService = {
  listDevices() {
    return request('/security/devices', () => devices);
  },

  revokeDevice(id: string) {
    return request('/security/devices/revoke', () => {
      devices = devices.filter((d) => d.id !== id);
      return devices;
    });
  },

  listEvents() {
    return request('/security/events', () => MOCK_SECURITY_EVENTS as SecurityEvent[]);
  },

  listLimits() {
    return request('/security/limits', () => limits);
  },

  updateLimit(id: string, limit: number) {
    return request('/security/limits', () => {
      limits = limits.map((l) => (l.id === id ? { ...l, limit } : l));
      return limits;
    });
  },

  verifyPin(pin: string) {
    return request('/security/pin', () => ({ valid: pin.length === 4 || pin.length === 6 }), { delay: 600 });
  },

  setupTwoFactor() {
    return request('/security/2fa/setup', () => ({
      secret: 'JBSWY3DPEHPK3PXP',
      otpauth: 'otpauth://totp/Peskedo:admin@keskedo.com?secret=JBSWY3DPEHPK3PXP&issuer=Peskedo',
      recoveryCodes: ['8K2L-9QXW', 'M4R7-2BVN', 'P0ZS-7TYE', 'Q5WD-1HCM'],
    }));
  },

  authenticateBiometric() {
    return request('/security/biometric', () => ({ success: Math.random() > 0.1 }), { delay: 1400 });
  },
};

export type { SecurityDevice, TransactionLimit };
